import {
  MATCH_ITEM,
  CONTEST_FILTER,
  SET_MY_TEAM_LIST,
  SET_CONTEST_TYPES,
  SET_MY_CONTEST_LIST
} from '../actions/fantasy-substitute-action-types';
import constants from '../constants';
import { createDeepObject } from '../utilities/helper';

const initialState = {
  item: {},
  contestFilter: createDeepObject(constants.ContestListFilter),
  isAppliedFilter: false,
  myTeamList: [],
  myContestList: [],
  contestTypes: {},
  contestCategories: {}
};

export default function fantasy(state = initialState, action: { type: any; payload: any }) {
  switch (action.type) {
    case MATCH_ITEM: {
      const item = action.payload;
      return {
        ...state,
        item: { ...item }
      };
    }
    case CONTEST_FILTER: {
      return {
        ...state,
        contestFilter: action.payload
      };
    }
    case SET_MY_TEAM_LIST: {
      return {
        ...state,
        myTeamList: action.payload
      };
    }
    case SET_CONTEST_TYPES: {
      return {
        ...state,
        contestTypes: action.payload
      };
    }
    case SET_MY_CONTEST_LIST: {
      return {
        ...state,
        myContestList: action.payload
      };
    }
    default:
      return state;
  }
}
